import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";

export const NameDialog = ({ open, onOpenChange, title, label, initial = "", submitLabel, templateLabel, onSubmit, testId }) => {
  const [name, setName] = useState(initial);
  const [template, setTemplate] = useState(true);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setName(initial); setTemplate(true); } }, [open, initial]);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    const ok = await onSubmit({ name: name.trim(), template });
    setBusy(false);
    if (ok) onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#15181E] border-[#2A2E39] text-white">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-wide">{title}</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor={`${testId}-input`}>{label}</Label>
            <Input id={`${testId}-input`} autoFocus value={name} onChange={(e) => setName(e.target.value)} className="h-12 bg-[#0B0C10] border-[#2A2E39]" data-testid={`${testId}-input`} />
          </div>
          <label className="flex items-center justify-between gap-3 rounded-md border border-[#2A2E39] p-3">
            <span className="text-sm text-slate-300">{templateLabel}</span>
            <Switch checked={template} onCheckedChange={setTemplate} data-testid={`${testId}-template-switch`} />
          </label>
          <DialogFooter>
            <Button type="submit" disabled={busy || !name.trim()} className="h-12 w-full bg-[#636b2f] text-white hover:bg-[#737c37] font-bold" data-testid={`${testId}-submit-btn`}>
              {busy ? "Salvando..." : submitLabel}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
